module.exports = __webpack_public_path__ + "cecb329f23e060c1a01e2bd2d493ab92.jpg";